/**
 * BRXWrapperOverlay
 *
 * Self-contained loading overlay primitive: progress ring, heading/message
 * setters, warmup animation, and reveal/hide logic.
 *
 * Usage:
 *   var overlay = window.BRXWrapperOverlay.create(sectionRoot);
 *   overlay.showWarmup(function onWarmupComplete() { ... });
 *   overlay.setHeading('Almost ready');
 *   overlay.hide();
 */
(function () {
    var WARMUP_MS = 5000;

    function create(root) {
        var overlayEl       = root ? root.querySelector('[data-intake-overlay]')        : null;
        var progressValueEl = root ? root.querySelector('[data-intake-progress-value]') : null;
        var progressBarEl   = root ? root.querySelector('[data-intake-progress-bar]')   : null;
        var headingEl       = root ? root.querySelector('[data-intake-status-heading]') : null;
        var messageEl       = root ? root.querySelector('[data-intake-status-message]') : null;

        var circleRadius        = 48;
        var circleCircumference = 2 * Math.PI * circleRadius;
        var progressRaf         = null;
        var hidden              = false;

        if (progressBarEl) {
            progressBarEl.style.strokeDasharray  = String(circleCircumference);
            progressBarEl.style.strokeDashoffset = String(circleCircumference);
        }

        function setHeading(text) { if (headingEl) headingEl.textContent = text; }
        function setMessage(text) { if (messageEl) messageEl.textContent = text; }

        function setProgress(value) {
            var next = Math.max(0, Math.min(100, Math.round(value)));
            if (progressValueEl) progressValueEl.textContent = next + '%';
            if (progressBarEl) {
                var offset = circleCircumference - (circleCircumference * next / 100);
                progressBarEl.style.strokeDashoffset = String(offset);
            }
        }

        function hide() {
            hidden = true;
            if (progressRaf) { cancelAnimationFrame(progressRaf); progressRaf = null; }
            if (overlayEl) {
                overlayEl.classList.add('is-hidden');
                overlayEl.setAttribute('aria-busy', 'false');
            }
        }

        // showWarmup can be called more than once (e.g. after "Resume intake").
        // It resets hidden state and restarts the animation.
        function showWarmup(onComplete) {
            hidden = false;
            if (overlayEl) {
                overlayEl.classList.remove('is-hidden');
                overlayEl.setAttribute('aria-busy', 'true');
            }

            var start = performance.now();
            setProgress(0);

            function tick(now) {
                if (hidden) return;
                var elapsed = now - start;
                var pct = (elapsed / WARMUP_MS) * 100;

                if (pct >= 100) {
                    setProgress(100);
                    if (typeof onComplete === 'function') onComplete();
                    // Only update copy if the overlay is still visible (not yet revealed)
                    if (!hidden) {
                        setHeading('Almost ready');
                        setMessage('Finalizing your intake\u2026');
                    }
                    return;
                }

                setProgress(pct);
                setHeading("It's time to step up your game in the bedroom.");
                setMessage('Answer a few questions to be matched with the right physician.');
                progressRaf = requestAnimationFrame(tick);
            }

            progressRaf = requestAnimationFrame(tick);
        }

        return { showWarmup, setHeading, setMessage, setProgress, hide };
    }

    window.BRXWrapperOverlay = { create: create };
})();
